<div class="preloader" [style.background-image]="'url(' + splashUrl + ')'">
  <div class="loader">
    <!-- Logo Animation -->
    <div id="logo__animation">
      <img *ngIf="logoUrl" [src]="logoUrl" alt="{{tenantName}}" />

    </div>
  </div>
</div>
